import { Button, Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import { MyPlannDrawer } from "web_myplann/Shared/Components/MyPlannDrawer";

type Props = {
	open: boolean;
	title: string;
	description: string;
	confirmLabel: string;
	cancelLabel: string;
	destructive?: boolean;
	isPending?: boolean;
	cancelAsLink?: boolean;
	grabber?: boolean;
	onConfirm: () => void;
	onClose: () => void;
};

export const ConfirmDrawer: FC<Props> = ({
	open,
	title,
	description,
	confirmLabel,
	cancelLabel,
	destructive,
	isPending,
	cancelAsLink,
	grabber = false,
	onConfirm,
	onClose,
}) => {
	const theme = useTheme();

	return (
		<MyPlannDrawer
			anchor="bottom"
			open={open}
			onClose={isPending ? undefined : onClose}
			title={title}
			closeButton={!grabber}
			grabber={grabber}
		>
			<Stack
				px={cancelAsLink ? theme.spacingTokens.lg : theme.spacingTokens.xl}
				pb={theme.spacingTokens.xl}
				gap={cancelAsLink ? theme.spacingTokens.lg : theme.spacingTokens.xl}
			>
				<Typography variant="body2">{description}</Typography>
				<Stack gap={cancelAsLink ? theme.spacingTokens.xs : 1}>
					{destructive ? (
						<Button
							variant="tertiary"
							color="error"
							loading={isPending}
							onClick={onConfirm}
						>
							{confirmLabel}
						</Button>
					) : (
						<Button variant="primary" loading={isPending} onClick={onConfirm}>
							{confirmLabel}
						</Button>
					)}
					{cancelAsLink ? (
						<Button
							variant="textLink"
							color="neutral"
							fullWidth
							disabled={isPending}
							onClick={onClose}
							sx={{ py: theme.spacingTokens.sm }}
						>
							{cancelLabel}
						</Button>
					) : (
						<Button variant="tertiary" disabled={isPending} onClick={onClose}>
							{cancelLabel}
						</Button>
					)}
				</Stack>
			</Stack>
		</MyPlannDrawer>
	);
};
